export const regexCorreoElectronico =
  /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

export const regexSoloLetrasYNumeros = /^[a-zA-Z0-9]+$/
